<template>
  <div class="mt-3">
    <!-- ------------------ -->
    <!--   delete confirm   -->
    <!-- ------------------ -->
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <!-- ---------- -->
    <!-- BUTTONS    -->
    <!-- ---------- -->
    <div class="col mt-3">
      <!-- ------------ -->
      <!--    cancel    -->
      <!-- ------------ -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Cancel"
            position="right"
          >
            <div v-if="isChanged">
              <img
                :src="cancelImg"
                @click="confirmExit()"
                height="48"
                width="48"
                alt="cancel image"
              />
            </div>
            <div v-else>
              <img
                :src="cancelImg"
                @click="exitHandler()"
                height="48"
                width="48"
                alt="cancel image"
              />
            </div>
          </ToolTip>
        </button>
      </div>
      <!-- ------------ -->
      <!--     save     -->
      <!-- ------------ -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="!isChanged"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <span>
            <ToolTip
              text="Save Sheet"
              position="right"
            >
              <img
                :src="saveImg"
                @click="saveCharacter()"
                height="70"
                width="70"
                alt="save sheet image"
              />
            </ToolTip>
          </span>
        </button>
      </div>
      <!-- ------------ -->
      <!--    delete    -->
      <!-- ------------ -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="isNewCharacter"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Delete Sheet"
            position="right"
          >
            <img
              :src="deleteImg"
              @click="confirmDeletion()"
              height="48"
              width="48"
              alt="delete sheet image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ------------------ -->
      <!--    export sheet    -->
      <!-- ------------------ -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="isNewCharacter"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Export Sheet"
            position="right"
          >
            <img
              :src="exportImg"
              @click="exportSheet()"
              height="60"
              width="60"
              alt="export sheet image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ---------------------------------------- -->
      <!--     add e.g. skill (specialism, lore)    -->
      <!-- ---------------------------------------- -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="!isAddTab"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
          @click="addObject()"
        >
          <ToolTip
            :text="isAddText"
            position="right"
          >
            <i
              class="bi bi-plus"
              style="color: white; font-size: 5em"
            ></i>
          </ToolTip>
        </button>
      </div>
      <!-- ---------------------- -->
      <!--     details/summary    -->
      <!-- ---------------------- -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="!isExpandableTab"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <!-- --------------------------------------------- -->
          <!--    where FALSE = currently showing summary    -->
          <!-- --------------------------------------------- -->
          <span v-if="!toggleDetails">
            <ToolTip
              text="Details"
              position="right"
            >
              <img
                :src="showDetailsImg"
                @click="detailsHandler()"
                height="48"
                width="48"
                alt="toggle details image"
              />
            </ToolTip>
          </span>
          <!-- --------------------------------------------- -->
          <!--    where TRUE = currently showing detailed    -->
          <!-- --------------------------------------------- -->
          <span v-if="toggleDetails">
            <ToolTip
              text="Summary"
              position="right"
            >
              <img
                :src="hideDetailsImg"
                @click="detailsHandler()"
                height="48"
                width="48"
                alt="toggle details image"
              />
            </ToolTip>
          </span>
        </button>
      </div>
      <!-- ---------------------- -->
      <!--    scroll right       -->
      <!-- ---------------------- -->
      <div
        v-if="toggleDetails"
        class="row d-flex justify-content-center"
      >
        <button
          type="button"
          :disabled="!isScrollableTab"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Scroll Right"
            position="right"
          >
            <img
              :src="rightImg"
              @click="scrollHandler('right')"
              height="48"
              width="48"
              alt="scroll right image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ------------------------------------------ -->
      <!--    scroll left (shown once scrolled right) -->
      <!-- ------------------------------------------ -->
      <div
        v-if="toggleDetails && showScrollLeftButton"
        class="row d-flex justify-content-center"
      >
        <button
          type="button"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Scroll Left"
            position="right"
          >
            <img
              :src="leftImg"
              @click="scrollHandler('left')"
              height="48"
              width="48"
              alt="scroll left image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ----------------------------------------- -->
      <!--    scroll down (only when rows overflow)  -->
      <!-- ----------------------------------------- -->
      <div
        v-if="canScrollDown"
        class="row d-flex justify-content-center"
      >
        <button
          type="button"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Scroll Down"
            position="right"
          >
            <img
              :src="downImg"
              @click="scrollHandler('down')"
              height="48"
              width="48"
              alt="scroll down image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ----------------------------------------- -->
      <!--    scroll up (once scrolled down)         -->
      <!-- ----------------------------------------- -->
      <div
        v-if="canScrollUp"
        class="row d-flex justify-content-center"
      >
        <button
          type="button"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Scroll Up"
            position="right"
          >
            <img
              :src="upImg"
              @click="scrollHandler('up')"
              height="48"
              width="48"
              alt="scroll up image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- ----------------------------------------- -->
      <!--    roll to DM                             -->
      <!-- ----------------------------------------- -->
      <div class="row d-flex justify-content-center">
        <button
          type="button"
          :disabled="isNewCharacter"
          class="mt-2 mb-2 btn btn-primary btn-xl btn-circle d-flex justify-content-center align-items-center"
        >
          <ToolTip
            text="Roll Dice"
            position="right"
          >
            <img
              :src="diceImg"
              @click="rollDiceHandler"
              height="48"
              width="48"
              alt="roll dice image"
            />
          </ToolTip>
        </button>
      </div>
      <!-- -------------------- -->
      <!--    end of buttons    -->
      <!-- -------------------- -->
    </div>
  </div>
</template>

<script>
// import CharacterLegend from '@/components/CharacterLegend.vue'
import ToolTip from '../components/ToolTip.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'

import saveImg from '../assets/images/bbSave.png'
import diceImg from '../assets/images/bbDice.png'
import exportImg from '../assets/images/bbExport.png'
import cancelImg from '../assets/images/bbExit100.png'
import deleteImg from '../assets/images/bbDelete48.png'
import showDetailsImg from '../assets/images/bbShowDesc.png'
import hideDetailsImg from '../assets/images/bbHideDesc.png'

import rightImg from '../assets/images/bbArrowRight.png'
import leftImg from '../assets/images/bbArrowLeft.png'
import upImg from '../assets/images/bbArrowUp.png'
import downImg from '../assets/images/bbArrowDown.png'

//==========================================================
// scripts
//---------
export default {
  name: 'CharacterSheetButtonsPanel',
  components: {
    ConfirmDialog,
    ToolTip,
  },
  //========================================================
  // props
  //-------
  props: {
    isNewCharacter: {
      type: Boolean,
      default: false,
    },
    isChanged: {
      type: Boolean,
      default: false,
    },
    character_name: {
      type: String,
      default: '',
    },
    character_idx: {
      type: Number,
      required: false,
      default: 0,
    },
    toggleDetails: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      required: true,
    },
    itemsCanScrollLeft: {
      type: Boolean,
      default: false,
    },
    itemsCanScrollRight: {
      type: Boolean,
      default: true,
    },
    itemsNextHorizontalDir: {
      type: String,
      default: 'right',
    },
    canScrollDown: {
      type: Boolean,
      default: false,
    },
    canScrollUp: {
      type: Boolean,
      default: false,
    },
  },
  //==========================================================
  // data
  //------
  data() {
    return {
      delete: false,
      saveImg,
      exportImg,
      cancelImg,
      deleteImg,
      showDetailsImg,
      hideDetailsImg,
      diceImg,
      rightImg,
      leftImg,
      upImg,
      downImg,
      toggleScrollVert: false, // false = show down, true = show up
      toggleScrollHorz: false, // false = show left, true = show right
    }
  },
  //==========================================================
  // computed
  //----------
  computed: {
    toolTipLeftRight() {
      if (this.toggleScrollHorz) {
        return 'Scroll Left'
      } else {
        return 'Scroll Right'
      }
    },
    toolTipUpDown() {
      if (this.toggleScrollVert) {
        return 'Scroll Up'
      } else {
        return 'Scroll Down'
      }
    },
    isScrollableTab() {
      return (
        this.activeTab.startsWith('skills-') ||
        this.activeTab.startsWith('items-') ||
        this.activeTab === 'runes'
      )
    },
    isExpandableTab() {
      return (
        this.activeTab.startsWith('skills-') ||
        this.activeTab.startsWith('items-') ||
        this.activeTab === 'runes'
      )
    },
    isAddTab() {
      return (
        this.activeTab === 'skills-specialisms' ||
        this.activeTab === 'skills-languages' ||
        this.activeTab === 'skills-lores' ||
        this.activeTab === 'skills-melee-weapons' ||
        this.activeTab === 'skills-ranged-weapons' ||
        this.activeTab === 'skills-casting' ||
        this.activeTab === 'runes' ||
        this.activeTab === 'counts' ||
        this.activeTab.startsWith('spells-') ||
        this.activeTab.startsWith('items-')
      )
    },
    isAddText() {
      return this.activeTab === 'skills-specialisms' ||
        this.activeTab === 'skills-melee-weapons' ||
        this.activeTab === 'skills-ranged-weapons' ||
        this.activeTab === 'skills-languages' ||
        this.activeTab === 'skills-lores' ||
        this.activeTab === 'skills-casting'
        ? 'Add Skill'
        : this.activeTab.startsWith('items-')
          ? 'Add Item'
          : this.activeTab === 'runes'
            ? 'Add Rune'
            : this.activeTab.startsWith('spells-')
              ? 'Add Spell'
              : 'Add Count'
    },
    showScrollRightButton() {
      if (this.activeTab.startsWith('items-')) {
        return this.itemsCanScrollRight
      }

      return !this.toggleScrollHorz
    },
    showScrollLeftButton() {
      if (this.activeTab.startsWith('items-')) {
        return this.itemsCanScrollLeft
      }

      return this.toggleScrollHorz
    },
    showBothItemHorizontalButtons() {
      return (
        this.activeTab.startsWith('items-') &&
        this.itemsCanScrollLeft &&
        this.itemsCanScrollRight
      )
    },
  },
  //==========================================================
  // methods
  //---------
  methods: {
    //----------------
    // scroll handler
    //----------------
    scrollHandler(dir) {
      // console.log('IN buttons scrollHandler dir = ' + dir)
      if (dir === 'left' || dir === 'right') {
        this.toggleScrollHorz = !this.toggleScrollHorz
      }
      // console.log('Emitting scroll-table with dir = ' + dir)
      this.$emit('scroll-table', dir)
    },
    //---------------------------------------------
    // add object handler (e.g. skill, item, rune)
    //---------------------------------------------
    addObject() {
      this.$emit('add-character-object', null)
    },
    //----------------------
    // export sheet handler
    //----------------------
    exportSheet() {
      this.$emit('export-character-sheet', null)
    },
    //-----------------
    // details handler
    //-----------------
    detailsHandler() {
      this.$emit('toggle-table-details')
    },
    //-------------------
    // roll dice handler
    //-------------------
    rollDiceHandler() {
      this.$emit('roll-dice')
    },
    //-----------------------------------------
    // exit handler (return to character view)
    //-----------------------------------------
    exitHandler() {
      this.$emit('close-character-sheet')
    },
    //----------------
    // save character
    //----------------
    saveCharacter() {
      this.$emit('save-character-sheet')
    },
    //------------------
    // confirm deletion
    //------------------
    async confirmDeletion() {
      this.delete = true
      const ok = await this.$refs.confirmDialog.show({
        title: 'Delete Character',
        message: 'Confirm Deletion',
        subject: this.character_name,
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        this.$emit('delete-character-sheet', this.character_idx)
        this.exitHandler()
      } else {
        this.delete = false
      }
    },
    //--------------
    // confirm exit
    //--------------
    async confirmExit() {
      this.exit = true
      const ok = await this.$refs.confirmDialog.show({
        title: 'Exit Character Sheet',
        message: 'Discard Changes?',
        subject: this.character_name,
        okButton: 'OK',
        cancelButton: 'Cancel',
      })
      if (ok) {
        this.exitHandler()
      } else {
        this.exit = false
      }
    },
  },
  mounted() {
    console.log('Mounted CharacterSheetButtonsPanel tab = ' + this.activeTab)
  },
}
</script>
